<template>
  <button
    v-on="$listeners"
    v-bind="$attrs"
    class="btn"
    :class="classButton">
    <slot />
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  inheritAttrs: false,
  props: {
    classButton: {
      type: String,
      default: ''
    }
  }
}
</script>
